import { render, staticRenderFns } from "./bottomUrl.vue?vue&type=template&id=6a7b4094&scoped=true"
import script from "./bottomUrl.vue?vue&type=script&lang=js"
export * from "./bottomUrl.vue?vue&type=script&lang=js"
import style0 from "./bottomUrl.vue?vue&type=style&index=0&id=6a7b4094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7b4094",
  null
  
)

export default component.exports